import React, { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import { useNotifications } from "./components/hooks/useNotifications";
import { usePwaInstall } from "./components/hooks/usePwaInstall";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { setTenantData } from "./redux/tenantSlice";
import axios from "axios";
import { configLink } from "./config";
import { initGA, initUmami } from "./utils";
import Landing from "./pages/Landing";
import BarcodeTest from "./pages/BarcodeTest";
import OfflineToast from "./components/OfflineToast";
import UserLanding from "./pages/UserLanding";
import ReclamationConsumer from "./pages/ReclamationConsumer";
import ReclamationMerchant from "./pages/ReclamationMerchant";
import InscriptionMerchant from "./pages/InscriptionMerchant";
import OtherRequestForm from "./pages/OtherRequestForm";
import SuggestionForm from "./pages/SuggestionForm";
import SurveyForm from "./pages/SurveyForm";
import TombolaForm from "./pages/TombolaForm";
import { set } from "date-fns";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const Reclamation = lazy(() => import('./pages/Reclamation'));
// const ReclamationDistributor = lazy(() => import('./pages/ReclamationDistributor'));
// const InscriptionCommercant = lazy(() => import('./pages/InscriptionCommercant'));

const App = () => {
  //* const [deferredPrompt, setDeferredPrompt] = useState(null);
  //* const [isIos, setIsIos] = useState(false); // checks if current device is running on iOS
  // // Derived: button is shown only when the browser has confirmed it is ready to install
  //* const isPWAInstallable = deferredPrompt !== null || isIos;
  const [currentLang, setCurrentLang] = useState("ar");
  const tenantName = useSelector((state) => state.tenant?.tenant.name);
  // const [isStandaloneMode, setIsStandloneMode] = useState(false);
  const [loading, setLoading] = useState(true);
  // Change the lang attribute of the html tag based on language state

  // const pwa = usePwaInstall();
  // console.log("PWA state:", pwa);

  useEffect(() => {
    document.documentElement.setAttribute("lang", currentLang);
  }, [currentLang]);

  // useEffect(() => {
  //   const handleBeforeInstallPrompt = (e) => {
  //     e.preventDefault();
  //     console.log('beforeinstallprompt event captured');
  //     localStorage.removeItem('pwaInstalled');
  //     localStorage.removeItem('canceledInstallation');
  //     setDeferredPrompt(e);
  //   };

  //   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

  //   // Hide the button immediately if the app is already installed (running in standalone mode)
  //   const checkInstallationStatus = () => {
  //     const isStandaloneMode =
  //       window.matchMedia('(display-mode: standalone)').matches ||
  //       window.navigator.standalone === true ||
  //       document.referrer.includes('android-app://');
  //     setIsStandloneMode(isStandaloneMode);
  //   };

  //   checkInstallationStatus();

  //   // Hide button as soon as the browser confirms the install completed
  //   const handleAppInstalled = () => {
  //     setDeferredPrompt(null);
  //   };
  //   window.addEventListener('appinstalled', handleAppInstalled);

  //   // Check for iOS
  //   const userAgent = window.navigator.userAgent.toLowerCase();
  //   const isIosPlatform = /iphone|ipad|ipod/.test(userAgent);
  //   setIsIos(isIosPlatform && !window.navigator.standalone);

  //   return () => {
  //     window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  //     window.removeEventListener('appinstalled', handleAppInstalled);
  //   };
  // }, []);

  useEffect(() => {
    // Initialize GA (only loads for *.jawdaplus.net domains)
    initGA();
  }, []);

  // const handleInstallClick = async () => {
  //   if (deferredPrompt) {
  //     const { outcome } = await deferredPrompt.prompt();
  //     if (outcome === 'accepted') {
  //       localStorage.setItem('pwaInstalled', 'true');
  //     } else {
  //       localStorage.setItem('canceledInstallation', 'true');
  //     }
  //     setDeferredPrompt(null);
  //   } else if (isIos) {
  //     alert("To install the app, tap the share button and then 'Add to Home Screen'");
  //   }
  // };

  // Initialize push notifications: checks subscription, requests permission, sends to backend
  useNotifications();

  const dispatch = useDispatch();

  // Get tenant data :
  // name: name of tenant
  // userFormFields : fields for consumer form
  // obligatoryUserFields : obligatory fields for consumer form
  // merchantFormFields: fields for merchant form
  // obligatoryMerchantFields: obligatory fields for merchant form
  // enabledModules:
  // termsOfUse: if true show termsOfUse popup
  // tipsModule: if true activate only tips
  // OtherRequest:if true activate OtherRequest module
  // recipesModule: if true activate only recipes module
  // consumerModule: if true activate consumer module
  // merchantModule: if true activate merchant module
  // tipsRecipesModule: if true activate both tips & recipes module
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${configLink}getTenantAdminConfigs`, {
        withCredentials: true,
      })
      .then((response) => {
        // Dispatch action to set tenant data in Redux state
        const fetchedTenantData = response.data;
        dispatch(setTenantData(fetchedTenantData));
        const iconPath = `tenants/${fetchedTenantData.name}/app-icon.png`;
        // **Dynamically update manifest.json**
        // const updateManifest = (tenantName, iconPath) => {
        //   const baseUrl = `https://${tenantName}.jawdaplus.click/user`
        //   const manifest = {
        //     short_name: tenantName,
        //     name: `${tenantName} App`,
        //     icons: [
        //       {
        //         src: `${baseUrl}/${iconPath}`, // Absolute URL for the icon
        //         type: "image/png",
        //         sizes: "144x144",
        //       },
        //       {
        //         src: `${baseUrl}/${iconPath}`, // Absolute URL for the icon
        //         type: "image/png",
        //         sizes: "512x512",
        //       },
        //     ],
        //     start_url: `${baseUrl}/`, // Absolute URL for start_url
        //     scope: `${baseUrl}/`, // Absolute URL for scope
        //     display: "standalone",
        //     theme_color: "#000000",
        //     background_color: "#ffffff",
        //   };

        //   const stringManifest = JSON.stringify(manifest, null, 2); // Pretty-print for debugging
        //   console.log('Generated Manifest:', stringManifest);

        //   const blob = new Blob([stringManifest], { type: "application/json" });
        //   const url = URL.createObjectURL(blob);
        //   console.log('Blob URL:', url);

        //   let manifestElement = document.querySelector("link[rel='manifest']");
        //   if (manifestElement) {
        //   const newManifestElement = document.createElement('link');
        //   newManifestElement.rel = 'manifest';
        //   newManifestElement.href = url;
        //   document.head.removeChild(manifestElement);
        //   document.head.appendChild(newManifestElement);

        //   // Additional PWA refresh for some browsers
        //   if (window.navigator && navigator.serviceWorker) {
        //     navigator.serviceWorker.getRegistrations().then(registrations => {
        //       registrations.forEach(registration => {
        //         registration.update();
        //       });
        //     });
        //   }
        // }
        // };

        // let tenantName = fetchedTenantData.name;
        // if (tenantName) {
        //   updateManifest(fetchedTenantData.name, iconPath);
        // }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching alerts:", error);
        setLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    if (tenantName) {
      initUmami(tenantName);

      // App icon according to current tenant
      const iconUrl = `/user/tenants/${tenantName}/app-icon.png`;

      const favicon = document.querySelector("link[rel='icon']");
      if (favicon) {
        favicon.href = iconUrl;
      } else {
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = iconUrl;
        document.head.appendChild(link);

        let appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");

        if (appleTouchIcon) {
          appleTouchIcon.href = iconUrl;
        } else {
          appleTouchIcon = document.createElement("link");
          appleTouchIcon.rel = "apple-touch-icon";
          appleTouchIcon.href = iconUrl;
          document.head.appendChild(appleTouchIcon);
        }
        if (tenantName === "base") {
          document.title = "Jawda";
        } else {
          // const captializedName= tenantName.charAt(0).toUpperCase() + tenantName.slice(1).toLowerCase();
          document.title = tenantName;
        }
      }
    }
  }, [tenantName]);

  // Simple loading component
  const RouteLoader = () => (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>
  );

  if (loading) {
    return (
      <Box sx={{ display: "flex", width: "100vw", height: "100vh", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress size={100} color="secondary" />
      </Box>
    );
  }
  const langProps = { currentLang, setCurrentLang };

  return (
    <>
      <Router basename="/user">
        <Routes>
          {/* <Route path="/" element={<FirstPage isPWAInstallable={isPWAInstallable} onInstallClick={handleInstallClick} isIos={isIos} currentLang={currentLang} setCurrentLang={setCurrentLang} />} />  */}
          <Route path="/" element={<UserLanding {...langProps} />} />
          <Route path="/barcode" element={<BarcodeTest />} />
          <Route path="/inscription_d" element={<InscriptionMerchant {...langProps} />} />
          <Route path="/reclamation_d" element={<ReclamationMerchant {...langProps} />} />
          <Route path="/reclamation_q" element={<ReclamationConsumer {...langProps} />} />
          <Route path="/contactez-nous" element={<OtherRequestForm {...langProps} />} />
          {/* the new Tombola (JawdaPlus_Tombola_B.html); production's FormulaireConcours stays in the code */}
          <Route path="/concours" element={<TombolaForm {...langProps} />} />
          <Route path="/suggest" element={<SuggestionForm {...langProps} />} />
          <Route path="/sondage" element={<SurveyForm {...langProps} />} />
        </Routes>

        {/* <ServiceWorkerRegistration /> */}
        <ToastContainer />
      </Router>
      <OfflineToast />
    </>
  );
};

export default App;
